import { render, staticRenderFns } from "./TournamentBracket.vue?vue&type=template&id=218117ac&scoped=true&"
import script from "./TournamentBracket.vue?vue&type=script&lang=js&"
export * from "./TournamentBracket.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBracket.vue?vue&type=style&index=0&id=218117ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218117ac",
  null
  
)

component.options.__file = "TournamentBracket.vue"
export default component.exports